import { eSupportedByHostFeature } from '../Enums/eSupportedByHostFeature';

const EPS_UNINSTALL_PASSWORD_FEATURE = eSupportedByHostFeature.EPS_UNINSTALL_PASSWORD.value;
const DRIVER_V2_FEATURE = eSupportedByHostFeature.DRIVER_V2.value;

export default {
  [EPS_UNINSTALL_PASSWORD_FEATURE]: {},
  [DRIVER_V2_FEATURE]: {}
};
